import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="flex items-center gap-3 font-sans text-[11px] tracking-[0.3em] uppercase text-[#6E6A61]">
    <span className="inline-block w-8 h-px bg-gradient-to-r from-[#1F1E1B]/40 to-transparent" />
    {children}
  </span>
);

export const SweepLink = ({ href, testid, children, small = false }) => (
  <a
    href={href}
    data-testid={testid}
    className={`group relative inline-flex items-center justify-center overflow-hidden border border-[#1F1E1B]/35 text-[#1F1E1B] hover:text-[#F6F4F0] transition-colors duration-500 ${
      small ? "px-5 py-2.5 text-[10px]" : "px-8 py-4 text-[11px]"
    } font-semibold uppercase tracking-[0.22em]`}
  >
    <span className="absolute inset-0 -translate-x-full bg-[#1F1E1B] transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-x-0" />
    <span className="relative z-10">{children}</span>
  </a>
);

export const ArrowLink = ({ to, testid, children, className = "" }) => (
  <Link
    to={to}
    data-testid={testid}
    className={`group inline-flex items-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-[#1F1E1B] ${className}`}
  >
    <span className="relative">
      {children}
      <span className="absolute -bottom-1 left-0 h-px w-full bg-[#1F1E1B]/25" />
      <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#1F1E1B] transition-[width] duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:w-full" />
    </span>
    <ArrowUpRight size={14} className="transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Link>
);
